import React, {useEffect} from "react";
import FinalBalanceTable from "./FinalBalanceTable";
import {useApp} from "../../utils/global-contexts/AppContext";

const FinalBalanceScreen = () => {
    const {setSelectedEstimate} = useApp()

    useEffect(() => {
        setSelectedEstimate(undefined);
    }, []);

    return (
        <FinalBalanceTable/>
    );
};


export default FinalBalanceScreen;
